export enum ModelTypeEnum {
	DTO = 'data transfer object',
	TMO = 'transitional model object',
	EMO = 'entity model object'
}

